import {createContext,useContext,type ReactNode} from "react";

export type ModuleHostIdentity=Readonly<{userId:string;organizationId:string;siteIds:string[];permissions:string[]}>;
const ModuleHostContext=createContext<{identity?:ModuleHostIdentity;readOnly:boolean}>({readOnly:false});

export function ModuleHostProvider({identity,readOnly=false,children}:{identity?:ModuleHostIdentity;readOnly?:boolean;children:ReactNode}){
  return <ModuleHostContext.Provider value={{identity,readOnly}}>{children}</ModuleHostContext.Provider>;
}

export function useModuleHost(){return useContext(ModuleHostContext)}
